import * as types from './types';

export const menuConfig = [
  {
    name: '数据统计',
    id: 1,
    children: [
      {
        name: '统计总览',
        path: 'statistics/overview',
        id: 2,
      },
    ],
  },
  {
    name: '账号管理',
    children: [
      {
        name: '账号列表',
        path: '/account',
        id: 4,
        children: [
          {
            name: '新增账号',
            path: '/account-create',
            id: 5,
          },
        ],
      },
    ],
  },
  {
    name: '机构管理',
    children: [
      {
        name: '机构列表',
        path: '/agency',
        id: 7,
        children: [
          {
            name: '新增机构',
            path: '/agency-create',
            id: 8,
          },
        ],
      },
    ],
  },
  {
    name: '学员管理',
    children: [
      {
        name: '学员列表',
        path: '/student',
        id: 10,
      },
    ],
  },
  {
    name: '报名管理',
    children: [
      {
        name: '学员报名列表',
        path: '/registration',
        id: 12,
      },
      {
        name: '考试审核列表',
        path: '/registration-video-list',
        id: 13,
      },
      {
        name: '考试进度列表',
        path: '/registration-process-list',
        id: 50,
      },
    ],
  },
  {
    name: '证书管理',
    children: [
      {
        name: '证书管理列表',
        path: '/cert',
        id: 23,
      },
      {
        name: '线下课程列表',
        path: '/course-offline-list',
        id: 46,
      },
    ],
  },
  {
    name: '广告管理',
    children: [
      {
        name: '广告列表',
        path: '/advertising',
        id: 24,
        children: [
          {
            name: '新增广告',
            path: '/advertising-create',
            id: 25,
          },
        ],
      },
    ],
  },
  {
    name: '分销系统',
    children: [
      {
        name: '平台分销记录',
        path: '/distribution',
        id: 26,
      },
      {
        name: '机构分销记录',
        path: '/distribution-agency-list',
        id: 27,
      },
      {
        name: '老师分销记录',
        path: '/distribution-teacher-list',
        id: 49,
      },
      {
        name: '学员分销记录',
        path: '/distribution-student-list',
        id: 28,
      },
      {
        name: '视频审核记录',
        path: '/distribution-video-list',
        id: 29,
      },
    ],
  },
  {
    name: '积分商城',
    children: [
      {
        name: '机构积分列表',
        path: '/points-list',
        id: 30,
      },
      {
        name: '商品列表',
        path: '/product-list',
        id: 31,
      },
      {
        name: '商品订单列表',
        path: '/product-order-list',
        id: 32,
      },
    ],
  },
  {
    name: '订单管理',
    children: [
      {
        name: '订单列表',
        path: '/order',
        id: 33,
      },
    ],
  },
  {
    name: '课程管理',
    children: [
      {
        name: '课程列表',
        path: '/course',
        id: 34,
      },
      {
        name: '课程类型列表',
        path: '/course-category',
        id: 35,
      },
      {
        name: '直播列表',
        path: '/live',
        id: 36,
      },
    ],
  },
  {
    name: '题库管理',
    children: [
      {
        name: '题库列表',
        path: '/test',
        id: 27,
      },
    ],
  },
  {
    name: '辅导员管理',
    children: [
      {
        name: '辅导员列表',
        path: '/counselor-list',
        id: 38,
      },
    ],
  },
  {
    name: '系统设置',
    children: [
      {
        name: '购课须知',
        path: '/config-purchase',
        id: 39,
      },
      {
        name: '考试须知',
        path: '/config-exam',
        id: 40,
      },
      {
        name: '理论考试',
        path: '/config-question-exam',
        id: 41,
      },
      {
        name: '视频考试',
        path: '/config-video-exam',
        id: 42,
      },
      {
        name: '热搜查询',
        path: '/config-hot-search',
        id: 43,
      },
      {
        name: '咨询电话',
        path: '/config-support',
        id: 44,
      },
      {
        name: '审核失败原因',
        path: '/config-reason',
        id: 45,
      },
    ],
  },
];
// 身份信息
export const identityInformation = [
  {
    label: '系统管理员',
    value: types.ADMINISTRATOR,
  },
  {
    label: '老师',
    value: types.TEACHER,
  },
];
// 身份信息
export const identityValidList = [
  {
    label: '全部',
    value: '',
  },
  {
    label: '启用',
    value: types.INDENTITY_VALID_ENABLE,
  },
  {
    label: '禁用',
    value: types.INDENTITY_VALID_DISABLE,
  },
];
// 身份信息
export const isBoughtList = [
  {
    label: '全部',
    value: '',
  },
  {
    label: '已购买',
    value: types.IS_STUDENT_BUY,
  },
  {
    label: '未购买',
    value: types.IS_STUDENT_NO_BUY,
  },
];
// 学员列表搜索字段
export const studentSearchList = [
  {
    label: '真实姓名',
    value: 'realName',
  },
  {
    label: '手机',
    value: 'mobilePhone',
  },
  {
    label: '身份证',
    value: 'idCard',
  },
];
// 学习进度列表搜索字段
export const processSearchList = [
  {
    label: '学员搜索',
    value: 'userSearch',
  },
  {
    label: '课程搜索',
    value: 'courseSearch',
  },
];
// 证书列表搜索字段
export const certSearchList = [
  {
    label: '证书号',
    value: 'certNoLike',
  },
  {
    label: '课程名',
    value: 'courseNameLike',
  },
  {
    label: '身份证',
    value: 'userIdCardLike',
  },
  {
    label: '姓名',
    value: 'userNameLike',
  },
];
// 课程类型
export const courseTypeList = [
  {
    label: '全部',
    value: '',
  },
  {
    label: '直播课程',
    value: 10,
  },
  {
    label: '岗前课程',
    value: 20,
  },
];
// 课程时间
export const classTypeList = [
  {
    label: '上午',
    value: 10,
  },
  {
    label: '下午',
    value: 20,
  },
];
// 直播状态
export const liveStatusList = [
  {
    label: '未开始',
    value: null,
  },
  {
    label: '直播中',
    value: 10,
  },
  {
    label: '已结束',
    value: 20,
  },
];
export const liveEventList = [
  {
    label: '推流成功',
    value: 10010,
  },
  {
    label: '直播断流',
    value: 10020,
  },
  {
    label: '录制已经成功开始',
    value: 20010,
  },
  {
    label: '录制已经成功暂停',
    value: 20020,
  },
  {
    label: '录制已经恢复继续录制',
    value: 20030,
  },
  {
    label: '录制文件生成',
    value: 20040,
  },
];
// 考试类型
export const examTypeList = [
  {
    label: '全部',
    value: '',
  },
  {
    label: '无考试',
    value: 10,
  },
  {
    label: '理论考试',
    value: 20,
  },
  {
    label: '视频考试',
    value: 30,
  },
  {
    label: '理论+视频考试',
    value: 40,
  },
];
// 考试状态类型
export const examStatusList = [
  {
    label: '进行中',
    value: 10,
  },
  {
    label: '未通过',
    value: 20,
  },
  {
    label: '通过',
    value: 30,
  },
  {
    label: '理论+视频考试',
    value: 40,
  },
];
// 考试状态类型
export const examVideoStatusList = [
  {
    label: '待上传',
    value: 10,
  },
  {
    label: '待领取',
    value: 20,
  },
  {
    label: '待审核',
    value: 30,
  },
  {
    label: '不通过',
    value: 40,
  },
  {
    label: '通过',
    value: 50,
  },
];
// 课程列表搜索字段
export const courseSearchList = [
  {
    label: '课程名称',
    value: 'courseName',
  },
  {
    label: '主讲老师',
    value: 'mainTeacherUserRealName',
  },
];
export const courseStatusList = [
  {
    label: '全部',
    value: '',
  },
  {
    label: '上架',
    value: types.COURSE_CATEGORY_ENABLE,
  },
  {
    label: '下架',
    value: types.COURSE_CATEGORY_DISABLE,
  },
];
// 课程状态
export const registrationStatusList = [
  {
    label: '全部',
    value: '',
  },
  {
    label: '待支付',
    value: 10,
  },
  {
    label: '已过时',
    value: 15,
  },
  {
    label: '已支付',
    value: 20,
  },
  {
    label: '学习完成',
    value: 30,
  },
  {
    label: '课程已通过',
    value: 55,
  },
  {
    label: '注册已过期',
    value: 60,
  },
];
// 课程退款状态
export const registrationRefundStatusList = [
  {
    label: '全部',
    value: null,
  },
  {
    label: '未退款',
    value: 0,
  },
  {
    label: '已退款',
    value: 1,
  },
];
// 商品类型
export const productTypeList = [
  {
    label: '全部',
    value: '',
  },
  {
    label: '课程抵用券',
    value: 10,
  },
  {
    label: '辅导员抵用券',
    value: 20,
  },
];
// 商品状态
export const productStatusList = [
  {
    label: '全部',
    value: '',
  },
  {
    label: '上架',
    value: types.PRODUCT_ENABLE,
  },
  {
    label: '下架',
    value: types.PRODUCT_DISABLE,
  },
];
// 学员列表搜索字段
export const orderSearchList = [
  {
    label: '商品名称',
    value: 'productName',
  },
  {
    label: '真实姓名',
    value: 'buyUserRealName',
  },
  {
    label: '券号',
    value: 'couponNumber',
  },
];

// 学员列表搜索字段
export const counselorValidList = [
  {
    label: '全部',
    value: '',
  },
  {
    label: '启用',
    value: types.COUNSELOR_ENABLE,
  },
  {
    label: '禁用',
    value: types.COUNSELOR_DISABLE,
  },
];

// 课程类型
export const courseCategoryList = [
  {
    label: '全部',
    value: '',
  },
  {
    label: '启用',
    value: types.COURSE_CATEGORY_ENABLE,
  },
  {
    label: '禁用',
    value: types.COURSE_CATEGORY_DISABLE,
  },
];

// 补考类型
export const targetTypeList = [
  {
    label: '理论补考',
    value: 20,
  },
  {
    label: '视频补考',
    value: 30,
  },
];
// 订单支付状态
export const DistributionTypeList = [
  {
    label: '平台分销',
    value: 10,
  },
  {
    label: '机构分销',
    value: 20,
  },
  {
    label: '学员分销',
    value: 30,
  },
  {
    label: '辅导员辅助',
    value: 40,
  },
  {
    label: '老师分销',
    value: 60,
  },
];
// 考试状态类型
export const distributionStatusList = [
  {
    label: '无',
    value: null,
  },
  {
    label: '待生效',
    value: 10,
  },
  {
    label: '用户已退款',
    value: 15,
  },
  {
    label: '已生效',
    value: 20,
  },
  {
    label: '已领取',
    value: 30,
  },
];
// 支付方式
export const payMethodList = [
  {
    label: '全部',
    value: null,
  },
  {
    label: '微信',
    value: 10,
  },
  {
    label: '后台',
    value: 20,
  },
];
// 支付方式
export const isRefundList = [
  {
    label: '是',
    value: 1,
  },
  {
    label: '否',
    value: 0,
  },
];

// 行业专题
export const evaluationList = [
  {
    label: '全部',
    value: null,
  },
  {
    label: '上架',
    value: types.EVALUATION_ENABLE,
  },
  {
    label: '下架',
    value: types.EVALUATION_DISABLE,
  },
];

// 供应商列表
export const agentList = [
  {
    label: '启用',
    value: types.AGENT_ENABLE,
  },
  // {
  //   label: '删除',
  //   value: types.AGENT_DELETE,
  // },
  {
    label: '禁用',
    value: types.AGENT_DISABLE,
  },
];

// 行业分类
export const evaluationCategoryList = [
  {
    label: '启用',
    value: types.EVALUATION_CATEGORY_ENABLE,
  },
  {
    label: '删除',
    value: types.EVALUATION_CATEGORY_DELETE,
  },
  {
    label: '禁用',
    value: types.EVALUATION_CATEGORY_DISABLE,
  },
];

// 行业抽奖
export const evaluationAwardList = [
  {
    label: '启用',
    value: types.EVALUATION_CATEGORY_ENABLE,
  },
  {
    label: '删除',
    value: types.EVALUATION_CATEGORY_DELETE,
  },
  {
    label: '禁用',
    value: types.EVALUATION_CATEGORY_DISABLE,
  },
];

// 优惠券类型
export const couponTypeList = [
  {
    label: '直播课程优惠券',
    value: 10,
  },
  {
    label: '通用课程优惠券',
    value: 20,
  },
  {
    label: '指定课程优惠券',
    value: 30,
  },
  {
    label: '测评宝抵用券',
    value: 40,
  },
];
// 测评宝订单状态
export const evaluationStatusList = [
  {
    label: '已支付(等待考试)',
    value: 20,
  },
  {
    label: '待抽奖',
    value: 30,
  },
  {
    label: '已结束',
    value: 40,
  },
];

// 优惠券获取来源
export const sourceTypeList = [
  {
    label: '报名',
    value: 10,
  },
  {
    label: '测评宝',
    value: 20,
  },
  {
    label: '管理员',
    value: 30,
  },
];

// 优惠券 状态
export const couponValidList = [
  {
    label: '上架',
    value: types.COUPON_ENABLE,
  },
  {
    label: '删除',
    value: types.COURSE_DELETE,
  },
  {
    label: '下架',
    value: types.COURSE_DISABLE,
  },
];
